import { call, delay, put, takeLatest } from 'redux-saga/effects';
import { actionTypes, requestFailure, requestSuccess } from './actions';
import { getLk20NotificationStatus } from '../../services/API';
import config from '../../../../config';

const intervalTimeout = config.oldVersionMessagesTimeout * 60 * 1000;

function* getHasLk20NotificationsStatus() {
  const response = yield call(getLk20NotificationStatus);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
  yield delay(intervalTimeout);
  yield call(getHasLk20NotificationsStatus);
}

export default function* checkLK20NotificationStatus() {
  yield takeLatest(actionTypes.GET_STATUS, getHasLk20NotificationsStatus);
}
